import React, { useEffect, useState } from "react";
import styles from "./ModalTransferAdminRole.module.css";
import Select from "../select/Select";
import Button from "../button/Button";
import * as api from "../../../service/labPersonalApi";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { RedirectCode400 } from "../../RedirectCode400";
import { CurrentUserContext } from "../../../App";

export default function ModalTransferAdminRole({ onClose, data }) {
  const { setIsMessage } = useContext(CurrentUserContext);
  const navigate = useNavigate();

  const [transfer, setTransfer] = useState("");
  const [optionTransfer, setOptionTransfer] = useState([]);

  useEffect(() => {
    setOptionTransfer(
      data.map((i) => {
        return {
          key: i["uid"],
          value: i["fname"] + " " + i["lname"],
        };
      }),
    );
  }, []);

  const clickTransfer = async () => {
    let res = await api.transferAdminRole(transfer);
    if (res) {
      if (res["data"]["code"] === 200) {
        onClose();
        localStorage.clear();
        navigate("/login");
      } else if (res["data"]["code"] === 403) {
        navigate(RedirectCode400());
      } else {
        setIsMessage({ type: "warning", data: res["data"]["message_th"] });
      }
    } else {
      setIsMessage({ type: "warning", data: res["data"]["message_th"] });
    }
  };

  return (
    <div className={styles.overlay}>
      <div className={styles.modalController}>
        <div className={styles.closeButton}>
          <img
            onClick={() => {
              onClose();
            }}
            src={require("../../../asset/icon/close-icon.svg").default}
          ></img>
        </div>
        <div className={styles.contentModal}>
          <div className={styles.title}>
            กรุณาเลือกชื่อผู้ปฏิบัติงานที่ต้องการโอนสิทธิ์
          </div>
          <hr className={styles.hrLine}></hr>
          <Select
            placeholder={"เลือกชื่อ"}
            disabledLabel
            value={transfer}
            setValue={setTransfer}
            list={optionTransfer}
          ></Select>
          <div className={styles.subTitle}>
            <div>หลังจากการโอนสิทธิ์แล้ว จะทำการออกจากระบบอัตโนมติ</div>
            <div>ท่านสามารถเข้าสู่ระบบได้อีกครั้ง และใช้งานในสถานะ</div>
            <div>ผู้ปฏิบัติงานในห้องปฏิบัติการ</div>
          </div>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Button
              style={{ width: "30%" }}
              onClick={() => {
                clickTransfer();
              }}
            >
              โอนสิทธิ์แอดมิน
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
